import {post,} from '../utils'

export default host => (id) =>
  post(`${host}/share_link/${id}/expire`)
    .then(response => response.json())
    .then(json => json.data)